function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 5.83329H12.75C12.3522 5.83329 11.9706 5.6577 11.6893 5.34514C11.408 5.03258 11.25 4.60865 11.25 4.16663V1.66663M2.25 6.33329V17C2.25 17.3536 2.37643 17.6927 2.60147 17.9428C2.82652 18.1928 3.13174 18.3333 3.45 18.3333H10.8M6.75 15C6.35218 15 5.97064 14.8244 5.68934 14.5118C5.40804 14.1992 5.25 13.7753 5.25 13.3333V3.33329C5.25 2.89127 5.40804 2.46734 5.68934 2.15478C5.97064 1.84222 6.35218 1.66663 6.75 1.66663H12L15 4.99996V13.3333C15 13.7753 14.842 14.1992 14.5607 14.5118C14.2794 14.8244 13.8978 15 13.5 15H6.75Z",
  stroke: "#626D7C",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7e2f184e.svg";
export { ForwardRef as ReactComponent };